import { render, staticRenderFns } from "./headActions.vue?vue&type=template&id=ef20971e&"
import script from "./headActions.vue?vue&type=script&lang=js&"
export * from "./headActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports